import PageHead from "../Head";
import HeaderContainer from "@/my_components/Header/HeaderContainer";
import Separator from "@/components/Common/Separator";
import MobileMenu from "@/my_components/Header/MobileMenu";
import BackToTop from "@/my_components/BackToTop/BackToTop_1";

import InstructorsRoom from "@/my_components/_Instructors/InstructorsRoom";

import Context from "@/context/Context";
import Footer from "@/my_components/Footer/Footer";

const index = () => {
  return (
    <>
      <PageHead title="Instructors | SmartTech Academy" />

        <Context>
          <MobileMenu />
          <HeaderContainer headerSticky="rbt-sticky" headerType="" />
          <InstructorsRoom />
          <BackToTop />

          <Separator />
          <Footer />
        </Context>
    </>
  );
};

export default index;
